import { GET } from 'api/crud';

import { baseURL } from 'api/client';

import { auth } from 'utils';


export default (token) => {
    return `${baseURL}/objects/downloadbytoken/${token}`
};
